export type EventTypeString = 'COLLAPSING_FINISHED';

export const eventType: EventTypeString = 'COLLAPSING_FINISHED';

export type EventType = {
  type: EventTypeString,
};

export const eventBuilder = (): EventType => ({
  type: eventType,
});
